import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const venueListViewI18n = {
	[ELocaleCode.RU_RU]: {
		add: 'Создать',
		archived: 'В архиве',
	},
	[ELocaleCode.EN_US]: {
		add: 'Create',
		archived: 'Archived',
	},
};
